import { render } from "./GiEdit.vue?vue&type=template&id=2931da07"
import script from "./GiEdit.vue?vue&type=script&lang=js"
export * from "./GiEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__